/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap'
// import './src/application.scss'
import '../src/styles'
//import 'stylesheets/application'
import WebpackerReact from 'webpacker-react'
import HelloReact from './hello_react'
import MainPageRoot from '../src/main_page/components/MainPageRoot.jsx'
import AddBtnEmployees from '../src/dashboard_employees/components/AddButton.jsx'
import EmployeesRoot from '../src/dashboard_employees/containers/EmployeesRoot'
import ImageEmployee from '../src/dashboard_employees/components/ImageEmployee.jsx'
import BarEmployee from '../src/dashboard_employees/components/BarEmployees.jsx'
import AddBtnTeams from '../src/employees_teams/components/AddTeamButton.jsx'
import TeamsRoot from '../src/employees_teams/containers/TeamsRoot'
import BarTeamEmployee from '../src/employees_teams/components/BarTeamEmployees.jsx'
import PictureEmployee from '../src/employess_details/components/Picture.jsx'
import EmployeeDRoot from '../src/employess_details/containers/EmployeeRoot'
import AddEmployeeRoot from '../src/add_employee/containers/AddEmployeeRoot'
import TeamForm from '../src/new_team/components/TeamForm'
import AddTeamRoot from '../src/new_team/containers/AddTeamRoot'
import MembersRoot from '../src/members_teams/containers/MembersRoot'
import AddDocumentRoot from '../src/add_document/containers/AddDocumentRoot'
import TemplatesRoot from '../src/templates/containers/TemplatesRoot'
import BarAccounting from '../src/dashboard_accounting/components/BarAccounting.jsx'
import AccountingRoot from '../src/dashboard_accounting/containers/AccountingRoot'
import AddTimeOffRoot from '../src/add_time_off/containers/AddTimeOffRoot'
import PublicHolidayRoot from '../src/delete_public_holiday/containers/PublicHolidayRoot'
import AddPublicHolidayRoot from '../src/add_public_holiday/containers/AddPublicHolidayRoot'
import BarStatistics from '../src/statistics/components/BarStatistics.jsx'
import StatisticsRoot from '../src/statistics/containers/StatisticsRoot'
import BarVacations from '../src/my_vacations/components/BarVacations.jsx'
import BarCalendar from '../src/calendars/components/BarCalendar'
import VacationsRoot from '../src/my_vacations/containers/VacationsRoot'
import HeaderRoot from '../src/header/containers/HeaderRoot'
import LoggedoutRoot from '../src/loggedout_page/containers/LoggedoutRoot'
import LoggedoutHeader from '../src/loggedout_page/components/LoggedoutHeader'
import NotificationsRoot from '../src/notifications/containers/NotificationsRoot'
import RequestsRoot from '../src/requests/containers/RequestsRoot'
import BarOncall from '../src/dashboard_oncallscheduler/components/BarOncall.jsx'
import OncallRoot from '../src/dashboard_oncallscheduler/containers/OncallRoot'
import TeamsoncallRoot from '../src/dashboard_teams/containers/TeamsoncallRoot'
import ReminderRoot from '../src/set_reminder/containers/ReminderRoot'
import SwapsRoot from '../src/swaps/containers/SwapsRoot'
import SignupRoot from '../src/signup_page/containers/SignupRoot'
import ProfileRoot from '../src/profile/containers/ProfileRoot'
import ChangeRoot from '../src/change_password/containers/ChangeRoot'
import BarLog from '../src/activity_log/components/BarLog.jsx'
import LogRoot from '../src/activity_log/containers/LogRoot'
//import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
WebpackerReact.setup({
  HelloReact,
  MainPageRoot,
  AddBtnEmployees,
  EmployeesRoot,
  ImageEmployee,
  BarEmployee,
  AddBtnTeams,
  TeamsRoot,
  BarTeamEmployee,
  PictureEmployee,
  EmployeeDRoot,
  AddEmployeeRoot,
  TeamForm,
  AddTeamRoot,
  MembersRoot,
  AddDocumentRoot,
  TemplatesRoot,
  BarAccounting,
  AccountingRoot,
  AddTimeOffRoot,
  PublicHolidayRoot,
  AddPublicHolidayRoot,
  BarStatistics,
  StatisticsRoot,
  BarVacations,
  BarCalendar,
  VacationsRoot,
  HeaderRoot,
  LoggedoutRoot,
  LoggedoutHeader,
  NotificationsRoot,
  RequestsRoot,
  BarOncall,
  OncallRoot,
  TeamsoncallRoot,
  ReminderRoot,
  SwapsRoot,
  SignupRoot,
  ProfileRoot,
  ChangeRoot,
  BarLog,
  LogRoot,
})
